import { useRoutes, useNavigate, useLocation } from 'react-router-dom';
import { RoutesConfig } from './routes';
import { useAppSelector } from './hooks/useAppSelector';
import { useEffect } from 'react';
import { useAppDispatch } from './hooks/useAppDipatch';
import { fetchBillingSummary } from './features/auth/authThunk';

export const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const element = useRoutes(RoutesConfig);

  useEffect(() => {
    const publicPages = ['/', '/signin', '/advertiser-terms', '/marketing-compliance-addendum', '/faq'];
    const isPublicPage = publicPages.includes(location.pathname);

    if (!isAuthenticated && !isPublicPage) {
      navigate(`/`);
    }
  }, [isAuthenticated, location.pathname, navigate]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchBillingSummary());
    }
  }, [dispatch, isAuthenticated]);

  return element;
};
